<template>
  <div class="action-bar">
    <span :class="{ disabled: isActive }" @click.prevent.stop="openStock">
      <icon name="chart-column" />
      <span>{{ columnText }}</span>
    </span>
    <slot />
    <span
      v-if="!isVirtual"
      class="detail"
      @click.prevent.stop="$emit('detail')"
    >
      <icon name="detail" />
      <span>{{ $t('trade.orders.detail') }}</span>
    </span>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Icon from 'com/Icon'
import isSameStock from 'utils/isSameStock'
import { SEC_TYPE } from 'const/stock'
export default {
  components: { Icon },
  props: {
    item: {
      required: true
    }
  },
  computed: {
    ...mapGetters(['activeStock', 'isVirtual', 'isIb']),
    isActive() {
      return isSameStock(this.activeStock, this.item)
    },
    isOPT() {
      return this.item.secType === SEC_TYPE.OPT
    },
    columnText() {
      return this.isOPT ? this.$t('menu.opt-price') : this.$t('menu.quote')
    }
  },
  methods: {
    openStock() {
      if (this.isActive) return
      if (this.isOPT) {
        const { expiry, strike, right } = this.item
        const query = { expiry, strike, right }
        this.$router.push({ path: '/quote/' + this.item.symbol, query })
      } else {
        this.$router.push('/quote/' + this.item.symbol)
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import '~uikit';

.action-bar {
  display: flex;
  align-items: center;
  height: 60px;
  background-color: var(--table-select-color);
  & > span {
    user-select: none;
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    flex-grow: 1;
    margin: 0;
    padding: 0;
    text-align: center;
    color: @light-grey;
    & > svg {
      margin-bottom: 3px;
    }
    &:hover:not(.disabled) {
      cursor: pointer;
      color: var(--active-color);
      span {
        color: var(--active-color);
      }
    }
  }
}
</style>
